var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRightCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3346 9C17.3346 13.6 13.593 17.3333 9.0013 17.3333L8.76816 17.3301C4.27582 17.2065 0.667969 13.522 0.667969 9C0.667969 4.40833 4.4013 0.666664 9.0013 0.666664C13.593 0.666664 17.3346 4.40833 17.3346 9ZM7.3513 5.66666C7.10964 5.91666 7.10964 6.30833 7.35964 6.55L9.81797 9L7.35964 11.45C7.10964 11.6917 7.10964 12.0917 7.3513 12.3333C7.6013 12.5833 7.99297 12.5833 8.23464 12.3333L11.143 9.44166C11.2596 9.325 11.3263 9.16666 11.3263 9C11.3263 8.83333 11.2596 8.675 11.143 8.55833L8.23464 5.66666C8.11797 5.54166 7.95964 5.48333 7.8013 5.48333C7.63464 5.48333 7.4763 5.54166 7.3513 5.66666Z",
    fill: "#253145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCircle);
export default __webpack_public_path__ + "static/media/chevron-right-circle.05eda75b91a3ff8cb24a81911440e103.svg";
export { ForwardRef as ReactComponent };